export const questionStatus = {
  answered: 'A',
  unanswered: 'U',
  answeredReview: 'AR',
  unansweredReview: 'NR',
  activeQuestion: 'active',
  review: 'R',
}

export const answerStatus = {
  incorrect: 'I',
  correct: 'C',
  partiallyCorrect: 'PC',
}

// Essay answer character limit for editor
export const essayAnswerLimit = 8000

//Question count based on it's status

export const questionStatusCount = (allQuestion, status) => {
  return allQuestion?.filter((val) => val?.attempt_status === status)?.length
}

//Side panel question colors based on it's status
export const getAttemptClass = (status: string) => {
  switch (status) {
    //Not Answered
    case questionStatus.unanswered:
      return ''
    //Answered
    case questionStatus.answered:
      return 'green'
    //Answered but marked for review
    case questionStatus.answeredReview:
      return 'warning'
    // Not answered but marked for review
    case questionStatus.unansweredReview:
      return 'warning'
    case questionStatus.activeQuestion:
      return 'primary'

    default:
      return ''
  }
}
